import React, { useState } from 'react';

import useDatawrapperResize from '@hooks/useDatawrapperResize';
import useEventTracking from '@hooks/useEventTracking';
import { graphics_path } from '@routes';
import { ClickTarget, TrackingLocation, click } from '@tracking';

import GraphicsPageContent from './Content';
import GraphicsPageRightRail from './RightRail';
import type { GraphicsLayoutProps } from './interfaces';

const GraphicsPageLayout = ({
  commentsCount,
  description,
  graphicSource,
  height,
  id,
  imageUrl,
  iframe,
  publishDate,
  relatedArticles,
  relatedGraphics,
  sourceUrl,
  title,
}: GraphicsLayoutProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const { Track, trackEvent } = useEventTracking({
    location: TrackingLocation.RightRail,
  });
  useDatawrapperResize();

  const handleSearchTermChange = (searchTerm: string) => {
    setSearchQuery(searchTerm);
    trackEvent(
      click({
        clickTarget: ClickTarget.SearchButton,
        clickLink: searchTerm,
      })
    );

    const newLink = `${graphics_path()}?query=${searchTerm}`;
    const anchor = document.createElement('a');
    anchor.href = newLink;
    anchor.click();
  };

  return (
    <main className="relative w-full px-16 sm:px-28">
      <div className="mx-auto flex w-full max-w-container-lg flex-col md:flex-row md:gap-72 xl:gap-112">
        <GraphicsPageContent
          commentsCount={commentsCount}
          description={description}
          graphicSource={graphicSource}
          height={height}
          id={id}
          imageUrl={imageUrl}
          iframe={iframe}
          publishDate={publishDate}
          relatedArticles={relatedArticles}
          sourceUrl={sourceUrl}
          title={title}
        />
        <Track>
          <GraphicsPageRightRail
            handleSearchTermChange={handleSearchTermChange}
            relatedGraphics={relatedGraphics}
            searchQuery={searchQuery}
          />
        </Track>
      </div>
    </main>
  );
};

export default GraphicsPageLayout;
